/**
 * @file tts.ts
 * @author liuchen(loocliu@tencent.com)
 */

import { CgiResp } from '@/services/cgi';
import { API_BOTH_PREFIX_TRPC, request } from '@/services/request';


interface IGetVoiceRequest {
  botId: string;
  userId: string;
  text: string;
}

interface IGetVoiceResponse {
  url: string;
}

export const getVoice = async (req: IGetVoiceRequest) => {
  const res = await request<CgiResp<IGetVoiceResponse>>(
    `${API_BOTH_PREFIX_TRPC}/TTS`,
    {
      method: 'POST',
      body: req,
    },
  );
  return res?.data?.url || '';
};
